import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

var jumptologin = '/login';
if (sessionStorage.getItem('token') != 'true') {
    jumptologin = '/login'
} else {
    jumptologin = '/home/'
}

export default new Router({
  //mode: 'history',
  base: process.env.BASE_URL,
  // base:'/cloud/',
  routes: [
    // {
    //   path: '/',
    //   redirect: '/login'
    // },
    {
      path: '*',
      component: () =>
        import('@/pages/login.vue'),
      meta: { title: '登录', keepAlive: false }
    },
    {
      path: '/home',
      name: 'index',
      component: () => import('@/pages/index.vue'),
      children: [
        {
          path: 'portal',
          name: '首页',
          component: () => import('@/pages/portal.vue'),
          children: []
        },
        {
          path: 'system/menu',
          name: '菜单管理',
          component: () => import('@/pages/system/menu.vue'),
          children: []
        },
        {
          path: 'system/role',
          name: '角色管理',
          component: () => import('@/pages/system/role.vue'),
          children: []
        },
        {
          path: 'system/user',
          name: '用户管理',
          component: () => import('@/pages/system/user.vue'),
          children: []
        },
        {
          path: 'system/dictionary',
          name: '字典管理',
          component: () => import('@/pages/system/dictionary.vue'),
          children: []
        },
        {
          path: 'system/hospital',
          name: '机构管理',
          component: () => import('@/pages/system/hospital.vue'),
          children: []
        },
//service
        {
          path: 'service/merchant',
          name: '商户管理',
          component: () => import('@/pages/service/merchant.vue'),
          children: []
        },{
          path: 'service/channel',
          name: '渠道管理',
          component: () => import('@/pages/service/channel.vue'),
          children: []
        },{
          path: 'service/orderMeange/orderQuery',
          name: '订单查询',
          component: () => import('@/pages/service/orderMeange/orderQuery.vue'),
          children: []
        },{
          path: 'service/orderMeange/refundQuery',
          name: '退款查询',
          component: () => import('@/pages/service/orderMeange/refundQuery.vue'),
          children: []
        },{
          path: 'service/orderMeange/verifyRecord',
          name: '对账记录',
          component: () => import('@/pages/service/orderMeange/verifyRecord.vue'),
          children: []
        },{
          path: 'service/orderMeange/unusualRecord',
          name: '汇总分析',
          component: () => import('@/pages/service/orderMeange/unusualRecord.vue'),
          children: []
        },{
          path: 'service/dataAnalysis/summary',
          name: '汇总分析',
          component: () => import('@/pages/service/dataAnalysis/summary.vue'),
          children: []
        },{
          path: 'service/dataAnalysis/operationAnalysis',
          name: '运营分析',
          component: () => import('@/pages/service/operationAnalysis.vue'),
          children: []
        },
//mobile
        {
          path: 'mobile/hosRegister',
          name: '医院注册',
          component: () => import('@/pages/mobile/hosRegister.vue'),
          children: []
        },
        {
          path: 'mobile/ClinicGuide',
          name: '就诊指南',
          component: () => import('@/pages/mobile/ClinicGuide.vue'),
          children: []
        },
        {
          path: 'mobile/featureList',
          name: '功能列表',
          component: () => import('@/pages/mobile/featureList.vue'),
          children: []
        },
        {
          path: 'mobile/classification',
          name: '图片分类',
          component: () => import('@/pages/mobile/classification.vue'),
          children: []
        },
        {
          path: 'mobile/imageUpload',
          name: '图片上传',
          component: () => import('@/pages/mobile/imageUpload.vue'),
          children: []
        },

        {
          path: 'mobile/deptIntr',
          name: '科室介绍',
          component: () => import('@/pages/mobile/deptIntr.vue'),
          children: []
        },

        {
          path: 'mobile/expertIntr',
          name: '专家介绍',
          component: () => import('@/pages/mobile/expertIntr.vue'),
          children: []
        },
      ]
    },

    {
      path: '/login',
      name: 'login',
      component: () => import('@/pages/login.vue')
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js